module.exports = __webpack_public_path__ + "static/media/graphene.9232b73e.png";